import { create } from 'zustand';

export type ToastKind = 'info' | 'success' | 'warn' | 'friend';

export interface Toast {
  id: string;
  kind: ToastKind;
  title: string;
  body?: string;
  /** Optional click action — runs then auto-dismisses. */
  onClick?: () => void;
  /** Auto-dismiss after this many ms. Default 5000. */
  ttlMs?: number;
  /** Optional preview image / icon */
  avatarColor?: 'red' | 'blue';
  avatarUrl?: string | null;
  characterUrl?: string | null;
}

interface ToastState {
  toasts: Toast[];
  push: (t: Omit<Toast, 'id'>) => string;
  dismiss: (id: string) => void;
  clear: () => void;
}

export const useToasts = create<ToastState>((set) => ({
  toasts: [],
  push: (t) => {
    const id = `${Date.now()}-${Math.random().toString(36).slice(2, 7)}`;
    const ttl = t.ttlMs ?? 5000;
    set((s) => ({ toasts: [...s.toasts, { ...t, id }] }));
    if (ttl > 0) {
      window.setTimeout(() => {
        set((s) => ({ toasts: s.toasts.filter((x) => x.id !== id) }));
      }, ttl);
    }
    return id;
  },
  dismiss: (id) => set((s) => ({ toasts: s.toasts.filter((x) => x.id !== id) })),
  clear: () => set({ toasts: [] }),
}));
